<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />

  <InformationsSection/>
  <PrestataireSection/>
  <CoutFormationSection/>
</template>
<script setup lang="ts">
  import CoutFormationSection from './sections/frais/CoutFormationSection.vue';
import InformationsSection from './sections/informations/InformationsSection.vue';
import PrestataireSection from './sections/prestataires/PrestataireSection.vue';

</script>
